var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m17.731 8.66-2.392-2.39L17.406 4.2h.003l2.39 2.39zM6.591 19.799h-2.39v-2.39l9.582-9.584 2.392 2.39zM21.356 5.035l-2.39-2.39a2.197 2.197 0 0 0-3.113 0l-2.068 2.068-1.556 1.556-9.906 9.906a1.1 1.1 0 0 0-.322.778v3.946A1.1 1.1 0 0 0 3.1 22h3.947a1.1 1.1 0 0 0 .779-.322l13.53-13.53a2.2 2.2 0 0 0 0-3.113"
})));
export default SvgGemEdit;